import React from "react"
import { View } from "react-native"
import { style } from "./styles"
import LinearGradient from "react-native-linear-gradient"
import { Header as NavigationHeader, StackHeaderProps } from "@react-navigation/stack"
import { colors } from "colors"
import { useColor } from "app/theme/getThemes"

export const Header = (props: StackHeaderProps | any) => {
  const { children } = props
    const { companyTheme } = useColor()

  // --------------------RENDER
  return (
    <View style={style.shadowHeader}>
      <LinearGradient
      colors={[companyTheme?.first, companyTheme?.second]}
      style={style.linearGradientContainer}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
      >
        <NavigationHeader {...props} />
        {children}
      </LinearGradient>
    </View>
  )
}
